import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { SchemaRouteStationInfo } from "../../project-schema/shared/interfaces/schema-route-station-info.interface";
import { ProjectRouteStation } from "../../shared/interfaces/project-route-station.interface";
import { AlertTypes } from "../../../shared/alert/shared/alert-types";
import { DeviceService } from "../../../device/shared/services/device.service";
import { AlertService } from "../../../shared/alert/shared/alert.service";
import { SelectInput } from "../../../shared/dropdown/shared/select-input.class";
import { EmnifyService } from "../../../device/shared/services/emnify.service";

@Component({
  selector: 'avs-test-area-additional-settings',
  templateUrl: './test-area-additional-settings.component.html',
  styleUrls: ['./test-area-additional-settings.component.css']
})
export class TestAreaAdditionalSettingsComponent implements OnChanges, OnInit {
  @Input() schemaInfo?: SchemaRouteStationInfo;
  @Input() activeStation?: ProjectRouteStation;
  public router: boolean = false;

  public isEvaCommandDropdownOpen: boolean = false;
  public evaCommandSelect: SelectInput[] = [];
  public selectedEvaCommand: SelectInput = { name: "Eva" };



  constructor(private deviceService: DeviceService,
    private alertService: AlertService,
    private emnifyService: EmnifyService) { }

  public ngOnInit(): void {
    this.emnifyService.getEvaSmsCommands().subscribe({
      next: commands => {
        this.evaCommandSelect = commands.map(command => ({ name: command.label, id: command.id }));
      },
      error: () => {
        this.isEvaCommandDropdownOpen = false;
      }
    });
  }

  /*  public ngOnChanges(): void {
     if (!this.activeStation) { return; }
     this.emnifyService.getRutOnlineStatus(this.activeStation.id).subscribe(RutState => {
       if (RutState) {
         this.router = RutState.online;
       }
     });
   } */

  public ngOnChanges(): void {
    if (!this.activeStation) { return; }
    if (this.schemaInfo?.online) {
      this.emnifyService.getRutOnlineStatus(this.activeStation.id).subscribe(RutState => {
        if (RutState) {
          this.router = RutState.online;
        }
      }, (err) => { this.alertService.alert("Router ist nicht online", AlertTypes.error) }
      );
    }
  }

  public onRefreshSolardataClicked(): void {
    this.deviceService.refreshDataFromChannels(this.activeStation?.id!).subscribe(data => this.alertService.alert("Solar Daten wurden aktualisiert", AlertTypes.info))
  }

  public onResetEvaClicked(): void {
    if (!this.activeStation) { return; }
    this.deviceService.resetDevice(this.activeStation.id, 0).subscribe(() => {
      this.alertService.alert("Eva Reset wurde ausgeführt", AlertTypes.info);
    });
  }

  public onevaCommandSStellcodeValueChange(selectItem: SelectInput): void {
    this.selectedEvaCommand = selectItem;
    this.isEvaCommandDropdownOpen = false
  }

  public onEvaCommandBtnClicked(commandId?: string | number): void {
    if (!this.activeStation || typeof commandId !== 'string') { return; }

    this.emnifyService.EmnifySendSmsToEva(this.activeStation.id, commandId).subscribe({
      next: () => this.alertService.alert("Der Befehl wurde an die EVA gesendet.", AlertTypes.info),
      error: () => undefined
    });
  }
}
